import { render, staticRenderFns } from "./certificateStatus.vue?vue&type=template&id=42c24254&scoped=true&"
import script from "./certificateStatus.vue?vue&type=script&lang=js&"
export * from "./certificateStatus.vue?vue&type=script&lang=js&"
import style0 from "./certificateStatus.vue?vue&type=style&index=0&id=42c24254&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c24254",
  null
  
)

export default component.exports